import classNames from "classnames";

export const styles = {
  container:
    "w-screen pt-8 lg:pt-0 z-20 relative h-full ml-[calc(50%-50vw)]",
  // 2xl:w-full 2xl:mx-auto

  text: classNames(
    "font-body font-bold uppercase leading-[110%] pb-6",
    "text-center max-w-[130px] md:max-w-[220px] lg:max-w-[430px]",
    "w-fit mx-auto absolute left-0 right-0",
    "!text-[8px] md:!text-[14px] lg:!text-[19px] xl:!text-[24px]",
    "bottom-[0px] md:bottom-[40px] lg:bottom-[100px] xl:bottom-[110px]",
  ),
};

export type S01ImageSlidesDefaultStyles =
  typeof styles;
